import useMarkActivityKeyAsRead from '../providers/ActivityAcknowledgement/useMarkActivityKeyAsRead';

export default useMarkActivityKeyAsRead;
